import React from "react";

function NoTableData() {
  return (
    <>
      <tr>
        <td colSpan={15}>No data found</td>
      </tr>
    </>
  );
}

export default NoTableData;